import React from "react";
import CopyIcon from "@/assets/icon/copy.svg"
import { isData } from "@/utility/helperFunctions";
import { copyDataToClipboard } from "@/utility/dataCopier";

import { useNotification } from "@/libraries/notification/NotificationContext"
import { NOTIFICATION } from "@/constants"

const DepositoryDetails = ({data}) => {

  const { sendNotification:sendToast } = useNotification(NOTIFICATION.TOAST);

  const copyData = (data) => {
    copyDataToClipboard(data)
    sendToast("Copied!")
  }

  return (
    <div className="tw-mt-4 tw-grid tw-grid-cols-4 tw-gap-4">
      <div className="tw-col-span-2">
        <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
          Unique Client Code
        </div>
        <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-inline-flex tw-items-center tw-gap-[6px]">
          {isData(data?.uniqueCientCode)} <span className="tw-cursor-pointer"><img alt="" src={CopyIcon} onClick={()=>copyData(data?.uniqueCientCode)}/></span>
        </div>
      </div>
      <div className="tw-col-span-2">
        <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
          Depository Name
        </div>
        <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
        CDSL
        </div>
      </div>
      <div className="tw-col-span-2">
        <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
          Demat Acc No/ BO ID
        </div>
        <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-inline-flex tw-items-center tw-gap-[6px]">
         {isData(data?.dp)} <span className="tw-cursor-pointer"><img alt="" src={CopyIcon} onClick={()=>copyData(data?.dp)}/></span>
        </div>
      </div>
      <div className="tw-col-span-2">
        <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
          Depository Participant
        </div>
        <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
        Torus Pvt. Ltd.
        </div>
      </div>
    </div>
  );
};

export default DepositoryDetails;
